export const style = `
._card_vzfn3_26{
    width:fit-content !important;
    min-width:8em !important;
}

.sensorsOnHandCard ._td_pebfd_14 {
    vertical-align: middle !important;
}
.sensorsOnHandCard ._card_vzfn3_26 ._headerDiv_vzfn3_168 {
    padding: var(--size-s) !important;
}
`
